module.exports = __webpack_public_path__ + "ru.d862459a3a5e0d105223.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/ru.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/ru.svg
// module chunks = styles